<template>
    <div class="last-buys tmp-block">
        <div class="title-contents">
            <div class="icon-holder">
                <img src="@/assets/icons/time-and-date.svg" alt="">
            </div>
            <h2>Последние покупки</h2>
        </div>
        <div class="buy-list">
            <div class="player" v-for="player of donaters">
                <img src="@/assets/icons/game-head.png" alt="">
                <div class="info">
                    <h3>{{player.login}}</h3>
                    <div class="state">
                        <p>{{player.date}}</p>
                        <tag :color="true ? 'green' : 'red'">Выдано</tag>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tag from '@/elements/tag.vue'
    import moment from "moment";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "last_buys",
        components: {
            tag,
        },
        data: () => ({
            list: [
                {
                    name: "Nikita23",
                    time: 1582044729745,
                    done: true,
                },
                {
                    name: "Nikita23",
                    time: 158204459745,
                    done: false,
                },
                {
                    name: "Nikita23",
                    time: 1583044729745,
                    done: true,
                },
                {
                    name: "Nikita23",
                    time: 156044729745,
                    done: true,
                },
                {
                    name: "Nikita23",
                    time: 1582044729745,
                    done: true,
                },
                {
                    name: "Nikita23",
                    time: 1582044729745,
                    done: true,
                },
            ]
        }),
        created(){
            if(!this.donaters.length){
                this.getDonaters();
            }
        },
        computed: {
            ...mapState('main', ['donaters'])
        },
        methods: {
            ...mapActions('main', ['getDonaters'])
        },
        filters: {
            getDate(time){
               return moment(time).calendar();
            }
        },
    }
</script>

<style scoped lang="scss">
    .last-buys {
        position: relative;
        padding: 32px !important;
        &::after{
            pointer-events: none;
            content: '';
            position: absolute;
            bottom: 32px;
            left: 0;
            right: 0;
            height: 100px;
            background: linear-gradient(180deg, rgba(14, 16, 20, 0) 0%, #0E1014 100%);

        }
        .buy-list {
            min-height: 100px;
            /*max-height: 408px;*/
            /*overflow-y: scroll;*/

            .player {
                $height: 48px;
                position: relative;
                height: $height;
                display: flex;
                align-items: flex-end;

                &:not(:last-of-type){
                    margin-bottom: 24px;
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: -12px;
                        left: 0;
                        right: 0;
                        height: 1px;
                        background-color: $bg_line;
                    }
                }

                img {
                    border-radius: 4px;
                    margin-right: 16px;
                    height: $height;
                }

                .info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 100%;

                    .state {
                        display: flex;

                        p {
                            margin-right: 8px;
                        }
                    }
                }
            }
        }
        @include mobile{
            padding: 32px 24px !important;
        }
    }
</style>